<template>
  <div style="max-width: 600px">
    <div>
      <div class="rounded-lg golden-border">
        <div class="border-gray-bottom d-flex justify-center">
          <h1 class="text-h4-center my-4 gold--text">
            {{ $t("messages.title") }}
          </h1>
        </div>
        <p class="mb-8 mx-4 mt-5 text-h5 black--text">
          רוצה לתרום ידע לאפליקצייה?
          <br />
          חושב שהמיקום לא מעודכן או שיש לך
          <br />
          פרט מעניין להוסיף?
          <br />
          נשמח להיות בקשר!
        </p>
      </div>

      <div class="border-radius-top backgroundGreen pa-7 white--text">
        <v-form ref="form" lazy-validation class="white--text">
          <v-radio-group
            row
            v-model="form.target"
            mandatory
            class="white--text"
          >
            <template slot="label">
              <span
                class="white--text text-h5"
                v-text="$t('messages.targetLabel') + ':'"
              />
            </template>
            <v-radio color="black" class="white--text" value="contact">
              <template slot="label">
                <span
                  class="white--text text- font-weight-bold"
                  v-text="$t('messages.contact')"
                />
              </template>
            </v-radio>
            <v-radio color="black" class="white--text" value="knowledge">
              <template slot="label">
                <span
                  class="white--text text- font-weight-bold"
                  v-text="$t('messages.knowledge')"
                />
              </template>
            </v-radio>
          </v-radio-group>
          <v-text-field
            v-model="form.fullName"
            autofocus
            :rules="nameValidationRule"
            @keypress.enter="submit"
            :placeholder="$t('userDetails.name')"
            solo
            background-color="white"
          >
            <template slot="label">
              <span class="red--text pl-1">*</span>
              <span class="">{{ $t("userDetails.name") }}</span>
            </template>
          </v-text-field>
          <v-text-field
            v-model="form.email"
            :rules="emailValidationRule"
            @keypress.enter="submit"
            :placeholder="$t('messages.emailField')"
            solo
            background-color="white"
          >
            <template slot="label">
              <span class="red--text pl-1">*</span>
              <span class="">{{ $t("messages.emailField") }}</span>
            </template>
          </v-text-field>
          <v-text-field
            v-model="form.phone"
            :rules="phoneValidationRule"
            @keypress.enter="submit"
            :placeholder="$t('userDetails.phone')"
            solo
            background-color="white"
          >
            <template slot="label">
              <span class="red--text pl-1">*</span>
              <span class="">{{ $t("userDetails.phone") }}</span>
            </template>
          </v-text-field>
          <v-textarea
            v-model="form.content"
            :rules="nameValidationRule"
            @keypress.enter="submit"
            :placeholder="$t('messages.messageField')"
            solo
            background-color="white"
          >
            <template slot="label">
              <span class="red--text pl-1">*</span>
              <span class="">{{ $t("messages.messageField") }}</span>
            </template>
          </v-textarea>
        </v-form>
        <div class="d-flex flex-column align-center">
          <v-alert
            icon="mdi-minus-circle"
            type="error"
            dense
            v-if="errorMessage"
            >{{ errorMessage }}</v-alert
          >
          <v-btn
            text
            v-text="loading ? '' : $t('generics.send') + ' >'"
            @click="submit"
            :loading="loading"
            class="white--text text-h4"
            elevation="4"
            height="50"
            width="200"
            rounded
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import validationMixins from "@/mixins/validation"

export default {
  name: "contact",
  props: {
    value: Boolean,
  },
  mixins: [validationMixins],
  data: () => ({
    form: {
      target: "contact",
      fullName: "",
      email: "",
      phone: "",
      content: "",
    },

    errorMessage: "",
    successMessage: "",
    loading: false,
  }),
  methods: {
    clearData(target = "contact") {
      for (const [key] of Object.entries(this.form)) {
        this.form[key] = ""
      }
      this.form.target = target
      this.$refs.form.resetValidation()
    },
    async submit() {
      this.loading = true
      this.errorMessage = ""
      this.successMessage = ""
      if (!this.validateForm()) {
        this.errorMessage = this.$t("errors.formInvalid")
        return
      }
      try {
        await this.$store.dispatch("message/store", {
          ...this.form,
          toastOptions: { message: "נשלח בהצלחה" },
        })
        this.clearData(this.form.target)
      } catch (err) {
        console.error(err.message)
      } finally {
        this.loading = false
      }
    },
    validateForm() {
      return this.$refs.form.validate()
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../styles/global.scss";
.golden-border {
  border: 2px solid var(--golden);
}
.border-gray-bottom {
  border-bottom: 1px solid var(--lightGrey);
}
.border-radius-top {
  border-radius: 15px 15px 0px 0px !important;
}
</style>
